export { default } from "./QuoteCarousel";
export * from "./QuoteCarousel";
export * from "./QuoteCarousel.model";
